// this is the same as FileSchema in the backend

export interface LearnInfoType {
  _id: string;
  chapterName: string;
  chapterFileName: string;
  filePath: string;
  sections: SectionType[];
  bokehWidgets: any[];
  chapterNumber?: string;
  chapterQuestions?: any;
  questions?: any[];
}

export type SectionType = {
  _id: string;
  sectionName: string;
  filePath: string;
  sectionNumber: string;
  sectionQuestions?: any;
};

export type CommonArticleType = {
  _id: string;
  customId: string;
  courseAuthorUserName: string;
  courseDescription: string;
  courseName: string;
  content: LearnInfoType[];
  articleType: ArticleType;
  totalStudents?: string | number | undefined;
  visibility?: string;
  user: string;
  progress?: number;
  // blogs specific fields
  tags?: string[];
  datePublished?: string;
  imageLink?: ArticleImageType;
  likes?: number;
  dislikes?: number;
  views?: number;
  // Todo: below fields can be populated from the api, and get users email, and profile photo,
  // to show the first 5 persons in a MUI Grouped avatar component
  viewedBy?: string[];
  likedBy?: string[];
  dislikedBy?: string[];
  bookmarkedBy?: string[];
  createdAt?: string;
  updatedAt?: string;
};



export enum DataStatus {
  loading = "loading",
  success = "success",
  failed = "failed",
}
export enum ArticleType {
  course = "course",
  blog = "blog",
  articleInfo = "articleInfo",
}
export enum ArticleVisibility {
  public = "public",
  private = "private",
}
export type ArticleImageType = {
  darkLogo: string;
  lightLogo: string;
};
